import styled, { css } from 'styled-components';

const styles = {
  default: css`
    color: #FFF;
    border: 2px solid #CC0000;
    background-color: #CC0000;
  `,
  white: css`
    color: #000;
    border: 2px solid #000;
    background-color: transparent;
  `,
};

const hoverStyles = {
  default: css`
    color: #FFF;
    border: 2px solid #900;
    background-color: #900;
  `,
  white: css`
    color: #FFF;
    border: 2px solid #000;
    background-color: #000;
  `,
};

const ButtonStyles = css`
  transition: all 150ms cubic-bezier(0.335, 0.015, 0.46, 0.995);
  box-sizing: border-box;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
  min-width: 190px;
  padding: 0 30px;
  height: 50px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;

  ${props => styles[props.theme] || styles['default']}
  &:hover {
    ${props => hoverStyles[props.theme] || hoverStyles['default']}
  };
`
export default {
  A: styled.a`
    ${ButtonStyles}
  `,
  Button: styled.button`
    ${ButtonStyles}
  `,
};
